import React from 'react';
import { motion } from 'framer-motion';
import Monitoring2 from '../Assets/iiot-monitoring.png';
import Monitoring3 from '../Assets/Monitoring2.png';
import './Monitoring.css';


const Monitoring = () => {
  const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };

  const textVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <div className="solution-page-container">
      <div className="solution-header">
        <h1>Monitoring</h1>
      </div>
      <div className="solution-content">
        {[
          {
            image: Monitoring2,
            alt: 'monitoring2',
            description:
              'Nos systèmes de surveillance sans fil permettent un suivi en temps réel des équipements sans câblage complexe. Ils offrent une solution rapide à déployer pour la collecte de données critiques (vibrations, température, consommation, etc.) dans les environnements industriels.',
          },
          {
            image: Monitoring3,
            alt: 'monitoring1',
            description:
              'Fiables et évolutifs, ces systèmes facilitent la maintenance prédictive, réduisent les temps d’arrêt et améliorent la sécurité des installations, tout en assurant une connectivité optimale même dans les zones difficiles d’accès.',
          },
        ].map((block, index) => (
          <div key={index} className="solution-block">
            <motion.div
              className="solution-block-image-container"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={imageVariants}
              custom={index}
            >
              <img src={block.image} alt={block.alt} className="solution-block-image" />
            </motion.div>
            <motion.div
              className="solution-block-text-container"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={textVariants}
              custom={index}
            >
              <p className="solution-block-description">{block.description}</p>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
   
  )
}

export default Monitoring
